/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Coupon,
    CouponFromJSON,
    CouponFromJSONTyped,
    CouponToJSON,
} from './Coupon';
import {
    Order,
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
} from './Order';

/**
 * 
 * @export
 * @interface OrderCoupon
 */
export interface OrderCoupon {
    /**
     * 
     * @type {Coupon}
     * @memberof OrderCoupon
     */
    couponByCouponId?: Coupon;
    /**
     * 
     * @type {number}
     * @memberof OrderCoupon
     */
    couponId?: number;
    /**
     * 
     * @type {Order}
     * @memberof OrderCoupon
     */
    orderByOrderId?: Order;
    /**
     * 
     * @type {number}
     * @memberof OrderCoupon
     */
    orderId?: number;
}

export function OrderCouponFromJSON(json: any): OrderCoupon {
    return OrderCouponFromJSONTyped(json, false);
}

export function OrderCouponFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderCoupon {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'couponByCouponId': !exists(json, 'couponByCouponId') ? undefined : CouponFromJSON(json['couponByCouponId']),
        'couponId': !exists(json, 'couponId') ? undefined : json['couponId'],
        'orderByOrderId': !exists(json, 'orderByOrderId') ? undefined : OrderFromJSON(json['orderByOrderId']),
        'orderId': !exists(json, 'orderId') ? undefined : json['orderId'],
    };
}

export function OrderCouponToJSON(value?: OrderCoupon | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'couponByCouponId': CouponToJSON(value.couponByCouponId),
        'couponId': value.couponId,
        'orderByOrderId': OrderToJSON(value.orderByOrderId),
        'orderId': value.orderId,
    };
}

